module.exports = __webpack_public_path__ + "img/Metamask-logo-blanc.bed86206.png";